var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"print",staticStyle:{"margin-top":"6px"}},[_vm._v("\n\tGerado por "),_c('strong',[_vm._v(_vm._s(_vm._nomeUsuario))]),_vm._v(" em "),_c('strong',[_vm._v(" "+_vm._s(_vm._now.format("DD/MM/YYYY HH:mm")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }